import { render, staticRenderFns } from "./TemplateTableOne.vue?vue&type=template&id=33a13653&scoped=true&"
import script from "./TemplateTableOne.vue?vue&type=script&lang=js&"
export * from "./TemplateTableOne.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTableOne.vue?vue&type=style&index=0&id=33a13653&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a13653",
  null
  
)

export default component.exports